import React from 'react'
import { UserGroupIcon } from 'components/Utils/Icons'

export default function UserGroupRow({ userGroup }) {
  return (
    <div className="flexbox flexbox-align-center">
      <UserGroupIcon className="shade-20 margin-horizontal-smaller" size={16} />
      <div className="margin-horizontal-normal font-weight-bold shade-05">
        {userGroup.name}
      </div>
    </div>
  )
}
